import { useEffect, useState } from "react";

/**
 * Scroll-driven parallax value.
 * Returns a translation amount in px based on window.scrollY * speed.
 * Use as: transform: `translateY(${offset}px)`
 */
export default function useParallax(speed = 0.3, max = 200) {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const next = Math.max(-max, Math.min(max, window.scrollY * speed));
        setOffset(next);
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(raf);
    };
  }, [speed, max]);

  return offset;
}
